// Shown for any URL that is not a real route. Existing pages, including
// /verify-email and /login (Firebase email continue URLs), are registered
// above the "*" route in App.js and never land here.
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import BrandName from '../components/BrandName';
import './NotFoundPage.css';

const NotFoundPage = () => {
  useEffect(() => { document.title = 'Page not found — The WasteGame'; }, []);

  return (
    <div className="nf-page">
      <div className="nf-card">
        <div className="nf-logo"><BrandName /></div>
        <p className="nf-code" aria-hidden="true">404</p>
        <h1 className="nf-title">Page not found</h1>
        <p className="nf-sub">
          That address isn’t on <BrandName inline />. It may have been moved, or the link might be wrong.
        </p>
        <Link to="/" className="btn btn-primary nf-btn">Back to home</Link>
      </div>
    </div>
  );
};

export default NotFoundPage;
